export * from './src/sidenav-view.component';
